<template>
   <div class="cropper">
      <vueCropper ref="cropper" :img="option.image" :output-size="1" :output-type="outputType" :info="true"
         :can-move="true" :can-move-box="true" :can-drag-box="true" :can-drag-img="true" :can-drag-out="false"
         :can-rotate="true" :auto-crop="true" :auto-crop-width="300" :auto-crop-height="180" :fixed-box="false"
         :fixed-data="false" :original="false" :center-box="false" :full="true" :crop="false" :rounded="false"
         :view-mode="1" :zoomable="true" :can-upload="true" :disabled="false" @cropend="handleCropEnd"
         @cropmove="handleCropMove" @cropstart="handleCropStart" @init="handleInit">
      </vueCropper>
      <div class="btnMain">
         <el-button class="btn" size="mini" @click="changeScale(1)">放大</el-button>
         <el-button class="btn" size="mini" @click="changeScale(-1)">缩小</el-button>
         <el-button class="btn" size="mini" @click="rotateLeft">旋转</el-button>
         <el-button class="btn uploadBtn" type="primary" size="mini">
            <el-upload class="uploadCompany" ref='upload_path' drag :show-file-list="false" :action="oss.host"
               :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload"
               accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG">
               <div class="uploadBox">
                  上传
               </div>
            </el-upload>
         </el-button>
         <el-button class="btn" type="primary" size="mini" @click="cropp">裁剪</el-button>
      </div>
   </div>
</template>

<script>
   export default {
      components: {

      },
      props: {
         // url: { type: String }
      },
      data() {
         return {
            option: {
               image: '',
            },
            outputType: 'jpeg',
            fileName: '',

            croppedImage: '',

            file: '',
            upload_data: {},
            oss: {
               host: "",
            },
         }
      },
      watch: {
         // url: {
         //    immediate: true,
         //    handler(val) {
         //       this.option.image = val;
         //    }
         // }
      },
      created() {

      },
      methods: {
         //放大/缩小
         changeScale(num) {
            num = num || 1;
            this.$refs.cropper.changeScale(num);
         },
         rotateLeft() {
            this.$refs.cropper.rotateLeft();
         },
         // 裁剪
         cropp() {
            this.$refs.cropper.getCropBlob((blob) => {
               // const urlCreator = window.URL || window.webkitURL;
               // const imageUrl = urlCreator.createObjectURL(blob);
               this.getOss().then(res => {
                  const formData = new FormData();
                  formData.append('name', this.file.name);
                  formData.append('key', this.oss.dir + `${this.file.name}`);
                  formData.append('policy', this.oss.policy);
                  formData.append('OSSAccessKeyId', this.oss.accessid);
                  formData.append('success_action_status', '200');
                  formData.append('callback', this.oss.callback);
                  formData.append('signature', this.oss.signature);
                  formData.append('Cache-Control', this.oss.cache_control);
                  formData.append('file', blob, this.file.name);
                  axios.post(this.oss.host, formData, {
                     headers: {
                        'Content-Type': 'multipart/form-data'
                     }
                  }).then(response => {
                     if (response.status === 200) {
                        this.$emit('upDataImage', response.data.data.base_url);
                     }
                  }).catch(err => { })
               })

            })
         },

         handleCropEnd(cropData) {
            // cropData 包含裁剪后的图片数据
            this.croppedImage = cropData.detail.dataURL;
         },
         handleCropMove(cropData) {
            // cropData 包含裁剪框移动时的数据
         },
         handleCropStart(cropData) {
            // cropData 包含裁剪开始时的数据
         },
         handleInit(cropData) {
            // 初始化时的数据
         },

         handleSuccess(res) {
            this.option.image = res.data.base_url;
         },
         beforeUpload(file) {
            this.file = file;
            return this.getOss();
         },
         // 上传 oss
         getOss() {
            return new Promise((resolve, reject) => {
               let self = this;
               window.axios.post(window.oss_url + "/tool/v1/oss.policy.get", {
                  operate_code: "shop-excel"
               }).then((response) => {
                  if (response.data.code == 0) {
                     self.oss = response.data.data;
                     self.upload_data = {
                        name: self.file.name,
                        key: self.oss.dir + "${filename}",
                        policy: self.oss.policy,
                        OSSAccessKeyId: self.oss.accessid,
                        success_action_status: "200",
                        callback: self.oss.callback,
                        signature: self.oss.signature,
                        'Cache-Control': self.oss.cache_control,
                     }
                     resolve();
                  }
               }).catch(() => {
                  reject();
               })
            })
         }
      }

   }
</script>

<style lang="scss" scoped>
   .cropper {
      width: 320px;
      height: 100%;
      padding-top: 6px;

      .vue-cropper {
         height: 200px;
      }
   }

   .btnMain {
      margin-top: 10px;
      display: flex;
      align-items: center;

      .uploadBtn {
         padding: 0;
      }

      .btn:first-child {
         margin-left: 0;
      }

      .btn {
         margin: 0 5px;
      }
   }

   .uploadCompany {
      width: 100%;

      display: flex;
      align-items: center;

      ::v-deep .el-upload:focus {
         color: #fff;
      }

      ::v-deep .el-upload:hover {
         color: #b21111;
      }

      ::v-deep .el-upload-dragger {
         width: 100%;
         height: 100%;
         background: none;
         border: 0;
         height: 26px;
         padding: 0 15px;
         display: flex;
         align-items: center;
      }
   }
</style>